// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3C8ei","author":"Table_author__1v4GQ","authorImage":"Table_authorImage__vLlkd","unreadRow":"Table_unreadRow__3PVTI"};